import React, { FC, useEffect, useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Label } from 'recharts';
import Props from './typing';
import './style.scss';
import Button from '../Button';
import imgURL from '../../lib/imgURL';
import { UiRoutes } from '../../lib/constants';
import CustomSwitch from '../../components/CustomSwitch';
import { connect } from 'react-redux';
import {
  getMerchantProfileAction,
  toggleEnvAction,
  clearToggleEnvAction,
} from '../../redux/actions/completeProfile';
import useRedirect from '../../hooks/useRedirect';
// import { setIsLiveMerchant } from '../../lib/localStorage';
import { updateToggleLoginState } from '../../redux/actions/login';
import { setCurrentRoute } from '../../lib/localStorage';
import { togglePath } from './constants';

const Banner: FC<Props> = (props): JSX.Element => {
  const { push, path } = useRedirect();
  const {
    completeProfileState,
    getMerchantProfileAction,
    isLiveMerchant,
    toggleEnvAction,
    toggleEnvState,
    updateToggleLoginState,
    clearToggleEnvAction,
    MerchantId,
    MerchantList,
  } = props;
  const [isTest, setTestEnv] = useState(!isLiveMerchant);
  const [profileDataset, setProfileDataset] = useState([
    { name: 'completed', value: 10, index: 0, color: '#45D1D0' },
    { name: 'pending', value: 90, index: 0, color: '#EBF2FC' },
  ]);
  const [statusMessage, setStatusMessage] = useState('');
  const [kycProfile, setKycProfile]: any = useState({});
  const [enableToggle, setEnableToggle] = useState(false);

  useEffect(() => {
    setTestEnv(!isLiveMerchant);
  }, [isLiveMerchant]);

  useEffect(() => {
    if(MerchantId !== '' && MerchantList?.length > 0) {
      const filteredMerchant = MerchantList.filter(item => item.merchantId === MerchantId || item.testMerchantId === MerchantId);
      if (filteredMerchant?.length > 0 && filteredMerchant[0].enableToggle === true) {
        setEnableToggle(false);
      } else {
        setEnableToggle(true);
      }
    }
  }, [MerchantId]);

  useEffect(() => {
    const { isSuccess, isFailure, data } = completeProfileState;
    if (isSuccess && data) {
      try {
        if (data?.profileStatus) {
          const statusData = data?.profileStatus;
          const kycdata = data?.merchantProfile?.kycProfile;
          setKycProfile(data?.merchantProfile?.kycProfile);
          setStatusMessage(kycdata?.comment || statusData?.message);
          setProfileDataset([
            {
              name: 'completed',
              value: Number(statusData?.status),
              index: 0,
              color:
                kycdata?.kycStatus.toLowerCase() === 'rejected' ||
                kycdata?.riskStatus.toLowerCase() === 'rejected'
                  ? '#FF0000'
                  : '#45D1D0',
            },
            {
              name: 'pending',
              value: Number(100 - statusData?.status),
              index: 0,
              color: '#EBF2FC',
            },
          ]);
        }
      } catch (e) {
        // no action
      }
    }

    if (isFailure) {
      // notify error
    }
  }, [completeProfileState]);

  useEffect(() => {
    const { isSuccess, data } = toggleEnvState;

    if (isSuccess && data) {
      updateToggleLoginState(data);
      if (path !== togglePath) {
        setCurrentRoute(path);
      }
      setTimeout(() => {push(UiRoutes.TOGGLEENV);},1000);
    }
  }, [toggleEnvState]);

  useEffect(() => {
    getMerchantProfileAction();

    return () => {
      clearToggleEnvAction();
    };
  }, []);

  return (
    <div className='banner-wrapper'>
      <div className='banner-content'>
        <div className='payout-pie-chart'>
          <ResponsiveContainer width='100%' height={72}>
            <PieChart width={72} height={72}>
              <Pie
                width={72}
                height={72}
                data={profileDataset}
                startAngle={90}
                endAngle={-270}
                dataKey='value'
                nameKey='name'
                innerRadius={26}
                outerRadius={36}
                cx='50%'
                cy='50%'
              >
                {profileDataset.map((item, i) => (
                  <Cell key={i} fill={item.color}></Cell>
                ))}{' '}
                <Label
                  style={{
                    fill: `${
                      kycProfile?.kycStatus?.toLowerCase() === 'rejected' ||
                      kycProfile?.riskStatus?.toLowerCase() === 'rejected'
                        ? '#FF0000'
                        : '#45D1D0'
                    }`,
                    fontSize: '1.25rem',
                  }}
                  className='status-text'
                  width={30}
                  position='center'
                >
                  {`${profileDataset[0].value}%`}
                </Label>
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className='banner-text'>
          <p className='banner-heading'>{statusMessage}</p>
          <p className='banner-label'>
            You&lsquo;re almost there—complete your business profile to start
            accepting payments.
          </p>
        </div>
        <div className='banner-actions'>
          <Button
            label='Complete KYC'
            btnStyleClass='primary-button'
            enable={true}
            btnIcon={<img className='back-icon' src={imgURL['left-arrow']} />}
            btnIconPosition='right'
            onClick={() => {
              push(UiRoutes.PROFILE);
            }}
          />
        </div>
        <div className='banner-video-section'>
          <div className='banner-toggler'>
            <div className='env-label'>You&lsquo;re in {`${isTest ? 'Test' : 'Live'} Environment`}</div>
            <div className='toggle-label'>
              <div className='toggle-text'>TEST MODE</div>
              <CustomSwitch
                className='banner-switch'
                disabled={enableToggle}
                onChange={(value: boolean) => {
                  setTestEnv(value);
                  toggleEnvAction();
                }}
                checked={isTest}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ completeProfileReducer, loginReducer }) => ({
  completeProfileState: completeProfileReducer?.completeProfileState,
  toggleEnvState: completeProfileReducer?.toggleEnvState,
  isLiveMerchant: loginReducer.loginState.isLiveMerchant,
  MerchantId: loginReducer?.loginState?.MerchantId,
  MerchantList: loginReducer?.loginState?.MerchantList,
});

export default connect(mapStateToProps, {
  getMerchantProfileAction,
  toggleEnvAction,
  updateToggleLoginState,
  clearToggleEnvAction,
})(Banner);
